import * as React from "react";
import { Label } from "components/bootstrap";
const EventTypeLabel = ({ isAlert }) => isAlert ? /* @__PURE__ */ React.createElement(Label, { bsStyle: "warning" }, "Alert") : /* @__PURE__ */ React.createElement(Label, { bsStyle: "info" }, "Event");
export default EventTypeLabel;
